const PictViewClass = require('pict-view');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class ObservationSearch extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.initialSearchResultsLoaded = false;

		this.DefaultSearchFilters = {
			Projects: [],
			ObservationTypes: [],
			StartDate: '',
			EndDate: '',
			SearchText: '',
			PageSize: 25,
			CurrentPage: 1,
			TotalPages: 1,
			SortBy: 'DesignatedTime',
			SortDirection: 'DESC',
		};
		this.CurrentSearchFilters = JSON.parse(JSON.stringify(this.DefaultSearchFilters));
		this.CurrentSearchFiltersCount = 0;
		this.CurrentSearchResults = [];
		this.selectedObservation = {};
		this.ObservationTypeManifest = [];
		this.SearchPanelMode = '';
		this.setSelected = false;

		// TODO: We should hide any columns that have exactly one search filter criteria, as they are redundant
		// ex: if you search for "Legacy Image" only, don't show the ObservationType column, bc all results will be "Legacy Image"
	}

	async onBeforeRenderAsync(pCallback)
	{
		if (typeof pCallback == 'function')
		{
			pCallback();
		};
	}

	async onAfterRenderAsync(pCallback)
	{
		// PROJECT Selector Filter
		// if we have a project already, make it sticky on the top of the list
		const tmpProject = this.AppData?.DocumentData?.ReportData?.IDProject ? { id: this.AppData?.DocumentData?.ReportData?.IDProject, text: this.AppData?.DocumentData?.ReportData?.Project?.Name } : null;
		this.initializeSelect2Plugin({
			dropdownCssClass: 'theme-dark' + (tmpProject ? ' has-sticky-option' : ''),
			placeholder: 'Search by projects...',
			ElementID: 'ObservationSearch-Projects',
			ParentID: 'ObservationSearch-SearchEntry',
			URL: 'Projects',
			IDField: 'IDProject',
			width: 'element',
			TextField: 'Name',
			StickyOption: tmpProject,
			PreselectOption: tmpProject, // && !this.initialSearchResultsLoaded, // NOTE: was causing weird bug: when re-opening panel the project dropdown filter was losing its value.
		}, () =>
		{
			this.log.info('Select2 Projects initialized');
		});

		// OBSERVATION TYPE Selector Filter
		this.initializeSelect2Plugin({
			dropdownCssClass: 'theme-dark has-sticky-option',
			placeholder: 'Select an observation types...',
			ElementID: 'ObservationSearch-ObservationTypes',
			ParentID: 'ObservationSearch-SearchEntry',
			URL: 'ObservationManifests',
			IDField: 'Name',
			TextField: 'DisplayName',
			StickyOption: { id: 'Legacy Image', text: 'Image' },
		}, () =>
		{
			this.log.info('Select2 ObservationTypes initialized');
		});

		// START DATE date picker
		window.flatpickr('#ObservationSearch-StartDate', {
			dateFormat: 'Y-m-d',
			onReady: function(dateObj, dateStr, instance)
			{
				_Pict.providers.UtilityProvider.buildFlatpickrExtraButtons(instance, 'ObservationSearch-StartDate');
			},
			onChange: function(selectedDates, dateStr, instance)
			{
				// a date was selected, update the End Date picker to disable dates before the start date
				/** @type {any} silence warnings about _flatpickr not being present */
				const siblingElement = document.getElementById('ObservationSearch-EndDate');
				siblingElement._flatpickr.config.minDate = dateStr ? dateStr : null;
				siblingElement._flatpickr.redraw();
			},
		});

		// END DATE date picker
		window.flatpickr('#ObservationSearch-EndDate', {
			dateFormat: 'Y-m-d',
			onReady: function(dateObj, dateStr, instance)
			{
				_Pict.providers.UtilityProvider.buildFlatpickrExtraButtons(instance, 'ObservationSearch-EndDate');
			},
			onChange: function(selectedDates, dateStr, instance)
			{
				// a date was selected, update the Start Date picker to disable dates after the end date
				/** @type {any} silence warnings about _flatpickr not being present */
				const siblingElement = document.getElementById('ObservationSearch-StartDate');
				siblingElement._flatpickr.config.maxDate = dateStr ? dateStr : null;
				siblingElement._flatpickr.redraw();
			},
		});

		this.setCurrentSearchFilters();
		// if we don't have search results, perform a search
		if (!this.initialSearchResultsLoaded)
		{
			this.initialSearchResultsLoaded = true;
			this.handleObservationSearch();
		}

		if (pCallback) pCallback();
	}

	/**
	 * This method performs an observation search based on the current search filters.
	 * @param {Event} [event] - The event that triggered the search.
	 * @return {Promise<void>}
	 * @async
	 */
	async handleObservationSearch(event)
	{
		// prevent the browser from refreshing on form submissions
		if (event)
		{
			event.preventDefault();
		}
		// add the loading spinner on the button when the action is being performed
		this.pict.ContentAssignment.addClass('#ObservationSearch-SearchButton', 'is-loading');
		// simulate that data is loading in the results table
		this.pict.views.HeadlightPanels.addLoadingSkeletonRows('ObservationSearch-Results-Container', this.CurrentSearchFilters.PageSize, '6rem');
		// toggle the filter panel closed
		this.pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup('ObservationSearchFilters', 'close');
		// perform the observation search
		await this.pict.providers.ObservationProvider.performObservationSearch(this.CurrentSearchFilters, (pSearchResults, pTotalSearchCount) =>
		{
			this.updateWithSearchResults(pSearchResults, pTotalSearchCount);
		});
	}

	/**
	 * This method initializes the select2 plugin.
	 * @param {Object} pOptions - The options to use for initialization.
	 * @param {Function} pCallback - The callback function to execute after initialization.
	 * @return {void}
	 */
	initializeSelect2Plugin(pOptions, pCallback)
	{
		$('#' + pOptions.ElementID).select2({
			dropdownParent: $('#' + pOptions.ParentID),
			dropdownCssClass: pOptions.dropdownCssClass || 'theme-dark',
			/* @ts-ignore */
			selectionCssClass: pOptions.selectionCssClass || 'theme-dark',
			placeholder: pOptions.placeholder || 'Select...',
			minimumInputLength: pOptions.minimumInputLength > -1 ? pOptions.minimumInputLength : this.pict.views.HeadlightPanels.MinimumInputLengthForSearch,
			language: {
				searching: function()
				{
					return pOptions.searchingMessage || 'Searching...';
				},
				noResults: function()
				{
					return pOptions.noResultsMessage || 'No results found.';
				},
				loadingMore: function()
				{
					return pOptions.loadingMoreMessage || 'Loading more results...';
				},
				inputTooShort: function(args)
				{
					return pOptions.inputTooShortMessage || 'Please enter at least ' + args.minimum + ' characters to see results.';
				},
			},
			ajax: {
				xhrFields: {
					withCredentials: true,
				},
				dataType: 'json',
				method: 'GET',
				url: function(params)
				{
					const tmpSearchQuery = {
						filters: [],
						pagination: {
							start: pOptions?.CurrentPage || 1,
							limit: pOptions?.PageSize || 25,
						},
					};
					// add the search term to the query if it exists
					if (params.term)
					{
						tmpSearchQuery.filters.push({
							field: pOptions.TextField,
							comparator: 'LK',
							target: params.term,
						});
					}
					const startCount = (tmpSearchQuery.pagination.start - 1) * tmpSearchQuery.pagination.limit;
					const endCount = tmpSearchQuery.pagination.start * tmpSearchQuery.pagination.limit;
					return `/1.0/${pOptions.URL}/${_Pict.providers.UtilityProvider.generateMeadowFilter(tmpSearchQuery)}/${startCount}/${endCount}`;
				},
				processResults: function(data, params)
				{
					params.page = params.page || 1;

					const tmpSelections = _Pict.views.ObservationSearch.CurrentSearchFilters[pOptions.URL] || [];

					return {
						results: _Pict.providers.UtilityProvider.formatSelect2Results(data, pOptions.IDField, pOptions.TextField, tmpSelections, pOptions.StickyOption),
						more: params.term ? data.length === _Pict.views.ObservationSearch.CurrentSearchFilters.PageSize : data.length === _Pict.views.ObservationSearch.CurrentSearchFilters.PageSize,
					};
				},
			},
		});
		// handle a preselected option if it exists
		if (pOptions.PreselectOption)
		{
			const select2 = $('#' + pOptions.ElementID);

			// create the option and append to Select2
			const option = new Option(pOptions.PreselectOption.text, pOptions.PreselectOption.id, true, true);

			select2.append(option).trigger('change');

			// manually trigger the `select2:select` event
			select2.trigger(
			{
				type: 'select2:select',
				params:
				{
					data: pOptions.PreselectOption,
				},
			});
		}
		// call the callback function if it exists
		if (pCallback)
		{
			pCallback();
		}
	}

	/**
	 * This method renders the previous page of search results.
	 * @return {void}
	 */
	renderPreviousPage()
	{
		if (this.CurrentSearchFilters.CurrentPage > 1)
		{
			this.CurrentSearchFilters.CurrentPage--;
		}
		else
		{
			this.CurrentSearchFilters.CurrentPage = 1;
		}
		this.pict.views.ObservationSearch.handleObservationSearch();
	}

	/**
	 * This method renders the next page of search results.
	 * @return {void}
	 */
	renderNextPage()
	{
		if (this.CurrentSearchFilters.CurrentPage < this.CurrentSearchFilters.TotalPages)
		{
			this.CurrentSearchFilters.CurrentPage++;
		}
		else
		{
			this.CurrentSearchFilters.CurrentPage = this.CurrentSearchFilters.TotalPages;
		}
		this.pict.views.ObservationSearch.handleObservationSearch();
	}

	/**
	 * This method resets the search filters to an empty state.
	 * @return {void}
	 */
	resetSearchFilters()
	{
		// reset the search filters to the default state
		this.CurrentSearchFilters = JSON.parse(JSON.stringify(this.DefaultSearchFilters));
		this.setCurrentSearchFiltersCount();
		this.renderAsync(() =>
		{
			this.log.info('Search filters reset');
		});
	}

	/**
	 * This method initializes the view and sets the default search filters.
	 * @param {object} pSearchFilters - The search filters to set.
	 * @return {void}
	 * @example
	 * setCurrentSearchFilters({Projects: [1234], ObservationTypes: ['Legacy Narrative'], SearchText: 'dog'})
	 */
	setCurrentSearchFilters(pSearchFilters)
	{
		// set the search filters to the passed in filters
		if (pSearchFilters)
		{
			this.CurrentSearchFilters = Object.assign(JSON.parse(JSON.stringify(this.DefaultSearchFilters)), pSearchFilters);
		}
		// if the search entry form exists (is actively the rendered panel), stuff the values into the form
		if (document.getElementById('ObservationSearch-SearchEntry'))
		{
			// convert the date strings to just the date part (we expect ISO strings)
			const tmpStartDate = this.CurrentSearchFilters?.StartDate ? this.CurrentSearchFilters?.StartDate.split('T')[0] : '';
			const tmpEndDate = this.CurrentSearchFilters?.EndDate ? this.CurrentSearchFilters?.EndDate.split('T')[0] : '';
			// for each filter, also stuff the values into the search form.
			this.pict.ContentAssignment.assignContent('#ObservationSearch-Projects', this.CurrentSearchFilters?.Projects);
			this.pict.ContentAssignment.assignContent('#ObservationSearch-ObservationTypes', this.CurrentSearchFilters?.ObservationTypes);
			this.pict.ContentAssignment.assignContent('#ObservationSearch-SearchText', this.CurrentSearchFilters?.SearchText || '');
			this.pict.ContentAssignment.assignContent('#ObservationSearch-CurrentPage', this.CurrentSearchFilters?.CurrentPage || 1);
			this.pict.ContentAssignment.assignContent('#ObservationSearch-PageSize', this.CurrentSearchFilters?.PageSize || 25);
			this.pict.ContentAssignment.assignContent('#ObservationSearch-StartDate', tmpStartDate);
			this.pict.ContentAssignment.assignContent('#ObservationSearch-EndDate', tmpEndDate);
			this.pict.ContentAssignment.assignContent('#ObservationSearch-SortBy', `${this.CurrentSearchFilters?.SortBy}_${this.CurrentSearchFilters?.SortDirection}`);
		}
		this.setCurrentSearchFiltersCount();
	}

	/**
	 * This method sets the current search filters count on the 'Set Filters' button.
	 * @return {void}
	 */
	setCurrentSearchFiltersCount()
	{
		this.CurrentSearchFiltersCount = 0;
		const my = this.CurrentSearchFilters;

		if (my.Projects && my.Projects.length > 0)
		{
			this.CurrentSearchFiltersCount += my.Projects.length;
		}
		if (my.ObservationTypes && my.ObservationTypes.length > 0)
		{
			this.CurrentSearchFiltersCount += my.ObservationTypes.length;
		}
		if (my.SearchText && my.SearchText.length > 0)
		{
			this.CurrentSearchFiltersCount += 1;
		}
		if (my.StartDate)
		{
			this.CurrentSearchFiltersCount += 1;
		}
		if (my.EndDate)
		{
			this.CurrentSearchFiltersCount += 1;
		}
	}

	/**
	 * Set the callback function for the search results.
	 * @param {Function} pCallback - The callback function to set.
	 * @return {void}
	 * @example
	 * setObservationSearchResultsCallback((pResults) => { console.log(pResults); });
	 */
	setObservationSearchResultsCallback(pCallback)
	{
		// TODO: not sure if this is the best way to handle this, but it works for now.
		this.observationSearchResultsCallback = pCallback;
	}

	/**
	 * Updates the search filter value based on the event and filter type.
	 * @param {string} pFilterType - The type of filter to update.
	 * @return {void}
	 * @example
	 * updateSearchFilterValue('Project');
	 */
	updateSearchFilterValue(pFilterType)
	{
		switch (pFilterType)
		{
		case 'Project':
		case 'Projects':
			this.CurrentSearchFilters.Projects = this.pict.ContentAssignment.readContent('#ObservationSearch-Projects');
			break;
		case 'ObservationType':
		case 'ObservationTypes':
			this.CurrentSearchFilters.ObservationTypes = this.pict.ContentAssignment.readContent('#ObservationSearch-ObservationTypes');
			break;
		case 'BeginDate':
		case 'StartDate':
			const tmpStartDate = this.pict.ContentAssignment.readContent('#ObservationSearch-StartDate');
			this.CurrentSearchFilters.StartDate = tmpStartDate ? tmpStartDate + 'T00:00:00.000Z' : '';
			break;
		case 'EndDate':
		case 'StopDate':
			const tmpEndDate = this.pict.ContentAssignment.readContent('#ObservationSearch-EndDate');
			this.CurrentSearchFilters.EndDate = tmpEndDate ? tmpEndDate + 'T23:59:59.000Z' : '';
			break;
		case 'SearchText':
			this.CurrentSearchFilters.SearchText = this.pict.ContentAssignment.readContent('#ObservationSearch-SearchText');
			break;
		case 'SortBy':
			const tmpSortBy = this.pict.ContentAssignment.readContent('#ObservationSearch-SortBy');
			this.CurrentSearchFilters.SortBy = typeof tmpSortBy == 'string' ? tmpSortBy.split('_')[0] : 'DesignatedTime';
			this.CurrentSearchFilters.SortDirection = typeof tmpSortBy == 'string' ? tmpSortBy.split('_')[1] : 'DESC';
			break;
		default:
			this.log.error(`Unknown filter type: ${pFilterType}`);
		}
		this.setCurrentSearchFiltersCount();
	}

	/**
	 * This method updates the search results/UI based on the search results and total search count passed in.
	 * @param {Array} pSearchResults - The search results to update with.
	 * @param {number} pTotalSearchCount - The total search count to update with.
	 * @return {void}
	 */
	updateWithSearchResults(pSearchResults, pTotalSearchCount)
	{
		// update our results list
		this.CurrentSearchResults = pSearchResults;
		// update the total possible count so we can calculate the total pages
		this.CurrentSearchFilters.TotalResultCount = pTotalSearchCount;
		this.CurrentSearchFilters.TotalPages = Math.ceil(pTotalSearchCount / this.CurrentSearchFilters.PageSize);
		// render the search results view
		this.pict.views.ObservationSearch.renderAsync('ObservationSearch-Results', '#ObservationSearch-Results-Container', false, false, () =>
		{
			// remove the loading spinner on the button when the action has been completed
			this.pict.ContentAssignment.removeClass('#ObservationSearch-SearchButton', 'is-loading');
			// render the pagination buttons
			this.pict.views.ObservationSearch.renderAsync('ObservationSearch-Pagination', '#ObservationSearch-Pagination-Container', false, false, () =>
			{
				this.pict.views.ObservationSearch.renderAsync('ObservationSearch-Pagination-State', '#ObservationSearch-Pagination-State-Container', false, false, () =>
				{
					this.log.info('Observation Search Pagination rendered');
				});
			});
			// if there is a callback function, call it
			if (this.observationSearchResultsCallback)
			{
				this.observationSearchResultsCallback(this.CurrentSearchResults);
			};
		});
	}

	/**
	 * This method handles the action popover for the observation search results.
	 * @param {Event} event - The event that triggered the popover.
	 * @param {string} pElementId - The ID of the element to attach the popover to.
	 * @param {number} pIDObservation - The ID of the observation.
	 */
	handleActionPopover(event, pElementId, pIDObservation)
	{
		// prevent the default action of the event
		if (event)
		{
			event.preventDefault();
			event.stopPropagation();
		}

		const isIncludedInForm = this.pict.providers.DocumentProvider.isObservationIncludedInDocument(pIDObservation);
		const tmpMenuElement = document.getElementById(pElementId);
		if (!tmpMenuElement)
		{
			this.pict.log.error(`Element with ID ${pElementId} not found for Observation search rults action popover.`);
			return;
		}
		// create the popover menu
		this.fable.HeadlightPopover.createPopover({
			PopoverDestinationAddress: pElementId,
			PopoverTemplateHash: 'ObservationSearch-Reults-Extra-Row-ActionMenu',
			PopoverTemplateRecord:
			{
				IDObservation: pIDObservation,
				IncludedInForm: isIncludedInForm,
			},
			theme: 'dropdown-dark',
		});
	}

	/**
	 * This method sets the mode of the search panel.
	 * @param {string} pMode - The mode to set the search panel to.
	 * @return {void}
	 */
	setMode(pMode)
	{
		this.SearchPanelMode = pMode;
		if (pMode === 'add-to-set')
		{
			this.setSelected = true;
		}
		else
		{
			this.setSelected = false;
		}
		// render the search entry form with the new mode
		this.renderAsync(() =>
		{
			this.pict.log.info('Search panel mode set to: ' + pMode);
		});
	}
}

module.exports = ObservationSearch;

module.exports.default_configuration =
{
	ViewIdentifier: 'ObservationSearch',
	DefaultRenderable: 'ObservationSearch-Entry',
	DefaultDestinationAddress: '#ObservationSearch-Entry-Container',
	CSS: /*css*/`
		.mode_add-to-set {
			display: none;
		}
		.hide-in-mode_add-to-folder {
			display: none;
		}
		.visible-mode_add-to-set .mode_add-to-set {
			display: block;
		}
		.mode_add-to-folder {
			display: none;
		}
		.visible-mode_add-to-folder .mode_add-to-folder {
			display: block;
		}
		.mode_add-to-root {
			display: none;
		}
		.visible-mode_add-to-root .mode_add-to-root {
			display: block;
		}`,
	Templates:
		[
			{
				Hash: 'ObservationSearch-Entry',
				Template: /*html*/`
				<div id="ObservationSearch-SearchEntry" class="container">
					<form autocomplete="off" role="observation-search" onsubmit="_Pict.views.ObservationSearch.handleObservationSearch(event);">
						<div class="px-4 pt-4" data-collapsible-content="ObservationSearchFilters">
							<div class="columns is-hidden">
								{~T:ObservationSearch-Entry-CurrentPage~}
								{~T:ObservationSearch-Entry-PageSize~}
							</div>
							<div class="columns">
								{~T:ObservationSearch-Entry-ProjectSelector~}
							</div>
							<div class="columns">
								{~T:ObservationSearch-Entry-ObservationTypeSelector~}
							</div>
							<div class="columns">
								{~T:ObservationSearch-Entry-StartDate~}
								{~T:ObservationSearch-Entry-EndDate~}
							</div>
							<div class="columns">
								{~T:ObservationSearch-Entry-SearchText~}
							</div>
						</div>
						<div class="buttons p-4 is-right" data-theme="dark">
							<div id="ObservationSearch-Pagination-Container" style="flex:auto"></div>
							<button class="button is-primary is-soft" type="button" data-collapsible-toggle="ObservationSearchFilters" title="Set filters" onclick="_Pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup('ObservationSearchFilters')" id="ObservationSearch-ToggleButton">
								<span class="icon">
									<i class="fas fa-fw fa-filter"></i>
								</span>
								<span>Set Filters</span>
								<!-- hide the badge until we fix the count to be accurate -->
								<span id="ObservationSearch-Entry-ActiveFilterCount" class="is-hidden badge is-warning">{~T:ObservationSearch-Entry-ActiveFilterCount~}</span>
							</button>
							<button class="button is-primary is-soft" type="button" id="ObservationSearch-ResetButton" title="Reset filters" onclick="_Pict.views.ObservationSearch.resetSearchFilters()"><i class="fas fa-fw fa-undo mr-1"></i> Clear Filters</button>
							<button class="button is-primary" type="submit" title="Search observations" id="ObservationSearch-SearchButton"><i class="fas fa-fw fa-search mr-1"></i> Search Observations</button>
							<div id="ObservationSearch-Pagination-State-Container"></div>
						</div>
					</form>
				</div>`,
			},
			{
				Hash: 'ObservationSearch-Entry-ActiveFilterCount',
				Template: /*html*/`{~D:Context[0].CurrentSearchFiltersCount~}`,
			},
			{
				Hash: 'ObservationSearch-Entry-CurrentPage',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="ObservationSearch-CurrentPage" class="block">Current Page</label>
						<input 
							id="ObservationSearch-CurrentPage" 
							type="number" 
							class="input" 
							placeholder="1" 
							onchange="_Pict.views.ObservationSearch.updateSearchFilterValue('CurrentPage')" 
							value=""
						/>
					</div>
				</div>`,
			},
			{
				Hash: 'ObservationSearch-Entry-PageSize',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="ObservationSearch-PageSize" class="block">Page Size</label>
						<input 
							id="ObservationSearch-PageSize" 
							type="number" 
							class="input" 
							placeholder="50" 
							onchange="_Pict.views.ObservationSearch.updateSearchFilterValue('PageSize')" 
							value=""
						/>
					</div>
				</div>`,
			},
			{
				Hash: 'ObservationSearch-Entry-ProjectSelector',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label block" for="ObservationSearch-Projects">Projects</label>
						<div class="control select is-fullwidth">
							<select 
								id="ObservationSearch-Projects" 
								onchange="_Pict.views.ObservationSearch.updateSearchFilterValue('Projects')"
								multiple
							></select>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'ObservationSearch-Entry-ObservationTypeSelector',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label block" for="ObservationSearch-ObservationTypes">Observation Types</label>
						<div class="control select is-fullwidth">
							<select 
								id="ObservationSearch-ObservationTypes" 
								onchange="_Pict.views.ObservationSearch.updateSearchFilterValue('ObservationTypes')"
								multiple
							></select>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'ObservationSearch-Entry-StartDate',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="ObservationSearch-StartDate" class="block">Start Date</label>
						<div class="control has-icons-left">
							<input 
								id="ObservationSearch-StartDate" 
								type="date" 
								class="input" 
								placeholder="Search by Start Date..." 
								onchange="_Pict.views.ObservationSearch.updateSearchFilterValue('StartDate')"
								value="" 
							/>
							<span class="icon is-small is-left">
								<i class="fas fa-calendar fa-xs"></i>
							</span>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'ObservationSearch-Entry-EndDate',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="ObservationSearch-EndDate" class="block">End Date</label>
						<div class="control has-icons-left">
							<input 
								id="ObservationSearch-EndDate" 
								type="date" 
								class="input" 
								placeholder="Search by End Date..." 
								onchange="_Pict.views.ObservationSearch.updateSearchFilterValue('EndDate')"
								value="" 
							/>
							<span class="icon is-small is-left">
								<i class="fas fa-calendar fa-xs"></i>
							</span>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'ObservationSearch-Entry-SortBy',
				Template: /*html*/`
				<div class="column">
					<div class="field">
						<label class="label" for="ObservationSearch-SortBy" class="block">Sort By</label>
						<div class="control select is-fullwidth">
							<select 
								id="ObservationSearch-SortBy" 
								type="date" 
								class="input" 
								placeholder="Search by End Date..." 
								onchange="_Pict.views.ObservationSearch.updateSearchFilterValue('SortBy')"
								value="" 
							>
								<option value="DesignatedTime_DESC">Designated Time (Newest)</option>
								<option value="DesignatedTime_ASC">Designated Time (Oldest)</option>
								<option value="ObservationType_ASC">Observation Type (A-Z)</option>
								<option value="ObservationType_DESC">Observation Type (Z-A)</option>
							</select>
						</div>
					</div>
				</div>`,
			},
			{
				Hash: 'ObservationSearch-Entry-SearchText',
				Template: /*html*/`
				<div class="column">
					<label class="label" for="ObservationSearch-SearchText" class="block">Text Search</label>
					<input 
						id="ObservationSearch-SearchText"
						type="text"
						class="input" 
						placeholder="Enter any specific text to search"
						onchange="_Pict.views.ObservationSearch.updateSearchFilterValue('SearchText')" 
						value=""
					/>
				</div>`,
			},
			{
				Hash: 'ObservationSearch-Results',
				Template: /*html*/`
				<div id="ObservationSearch-Results-Container" class="container table-container">
					{~TIfAbs:ObservationSearch-Results-Empty:Context[0]:Context[0].CurrentSearchResults.length^==^0~}
					{~TIfAbs:ObservationSearch-Results-Table:Context[0]:Context[0].CurrentSearchResults.length^>^0~}
				</div>`,
			},
			{
				Hash: 'ObservationSearch-Results-Table',
				Template: /*html*/`
				<table class="table is-striped is-hoverable is-fullwidth has-sticky-table-header">
					<thead>
						<tr>
							<th>Designated Time</th>
							<th>Type</th>
							<th>Creating User</th>
							<th>Project</th>
							{~T:ObservationSearch-Results-Extra-Header~}
						</tr>
					</thead>
					<tbody id="ObservationSearch-ResultsEntries">
						{~TS:ObservationSearch-Results-Row:Record.CurrentSearchResults~}
					</tbody>
				</table>`,
			},
			{
				Hash: 'ObservationSearch-Results-Row',
				Template: /*html*/`
				<tr onclick="_Pict.views.HeadlightPaneObservations.handleObservationImagePreviewClick(event, '{~D:Record.IDObservation~}', 'Search')" data-observation-id="{~D:Record.IDObservation~}">
					<td>{~DateFormat:Record.DesignatedTime^YYYY-MM-DD~}</td>
					<td>{~ObsTypeDisplay:Record.ObservationType~}</td>
					<td>{~Entity:User^Record.CreatingIDUser^ObservationSearch-Results-User^~}</td>
					<td>{~Entity:Project^Record.IDProject^ObservationSearch-Results-Project^~}</td>
					{~T:ObservationSearch-Results-Extra-Row:Record~}
				</tr>`,
			},
			{
				Hash: 'ObservationSearch-Results-Extra-Header',
				Template: /*html*/`
				<th>Thumbnail</th>
				<th>Actions</th>`,
			},
			{
				Hash: 'ObservationSearch-Results-Extra-Row',
				Template: /*html*/`
				<td>
					<a class="preview-image-wrapper" style="min-width:100px; min-height:100px">
						<img class="preview-image is-skeleton" height="128" width="128" src="/1.0/Observation/{~D:Record.IDObservation~}/Image/Thumbnail-Dense{~CacheBustPostfix:~}" 
							alt="Observation Preview for #{~D:Record.IDObservation~}" onload="_Pict.views.HeadlightPanels.removeLoadingSkeleton(this)" />
					</a>
				</td>
				<td class="is-vcentered">
					<button
						id="PANEL-MENU-BUTTON-FOR-OBSERVATION-{~D:Record.IDObservation~}"
						class="button icon-button is-ghost has-text-primary-60 p-0 ml-3 is-size-5"
						style="float: none"
						title="Actions"
						type="button"
						aria-haspopup="true"
						onmouseover="_Pict.views.ObservationSearch.handleActionPopover(event, id, '{~D:Record.IDObservation~}')"
						onclick="_Pict.views.ObservationSearch.handleActionPopover(event, id, '{~D:Record.IDObservation~}')"
						data-observation-id="{~D:Record.IDObservation~}">
						<span class="icon is-small">
							<i class="fas fa-circle-ellipsis" aria-hidden="true"></i>
						</span>
					</button>
				</td>`,
			},
			{
				Hash: 'ObservationSearch-Reults-Extra-Row-ActionMenu',
				Template: /*html*/`
				<ul class="list-menu visible-mode_{~D:Pict.views.ObservationSearch.SearchPanelMode~}">
					<li class="list-menu-item mode_add-to-set">
						<a onclick="_Pict.views.HeadlightPaneObservations.handleObservationListSelection(event, '{~D:Record.IDObservation~}', 'add-to-set');_Pict.fable.HeadlightPopover.hidePopover(event, '{~D:Record.IDObservation~}');">
							<span class="icon">
								<i class="fas fa-plus-circle"></i>
							</span>
							<span>Add to Set</span>
						</a>
					</li>
					<li class="list-menu-item mode_add-to-folder">
						<a onclick="_Pict.views.HeadlightPaneObservations.handleObservationListSelection(event, '{~D:Record.IDObservation~}', 'add-to-folder');_Pict.fable.HeadlightPopover.hidePopover(event, '{~D:Record.IDObservation~}');">
							<span class="icon">
								<i class="fas fa-file-plus"></i>
							</span>
							<span>Add File to Folder</span>
						</a>
					</li>
					<li class="list-menu-item mode_add-to-root">
						<a onclick="_Pict.views.HeadlightPaneObservations.handleObservationListSelection(event, '{~D:Record.IDObservation~}', 'add-to-root');_Pict.fable.HeadlightPopover.hidePopover(event, '{~D:Record.IDObservation~}');">
							<span class="icon">
								<i class="fas fa-file-plus"></i>
							</span>
							<span>Add File to Project Files</span>
						</a>
					</li>
					<li class="list-menu-item {~Hide:Record.IsObservationLinked~}{~Hide:Pict.views.ObservationSearch.setSelected~}">
						<a onclick="_Pict.views.HeadlightPaneObservations.handleObservationListSelection(event, '{~D:Record.IDObservation~}', 'add-to-document');_Pict.fable.HeadlightPopover.hidePopover(event, '{~D:Record.IDObservation~}');">
							<span class="icon">
								<i class="fas fa-link"></i>
							</span>
							<span>Include in document</span>
						</a>
					</li>
					<li class="list-menu-item {~Show:Record.IsObservationLinked~}">
						<a onclick="_Pict.views.HeadlightPaneObservations.handleObservationListSelection(event, '{~D:Record.IDObservation~}', 'remove-from-document');_Pict.fable.HeadlightPopover.hidePopover(event, '{~D:Record.IDObservation~}');">
							<span class="icon">
								<i class="fas fa-unlink"></i>
							</span>
							<span>Remove from document</span>
						</a>
					</li>
				</ul>`,
			},
			{
				Hash: 'ObservationSearch-Pagination',
				Template: /*html*/`
				<nav id="ObservationSearch-Pagination" class="pagination" style="justify-content: flex-start;" role="navigation" aria-label="pagination">
					<button id="ObservationSearch-PreviousButton" type="button" title="Previous page" class="button is-soft mr-2" onclick="_Pict.views.ObservationSearch.renderPreviousPage();">
						<span class="icon">
							<i class="fas fa-fw fa-chevron-left"></i> 
						</span>
						<span>Previous</span>
					</button>
					<button id="ObservationSearch-NextButton" type="button" title="Next page" class="button is-soft" onclick="_Pict.views.ObservationSearch.renderNextPage();">
						<span>Next</span> 
						<span class="icon">
							<i class="fas fa-fw fa-chevron-right ml-1"></i>
						</span>
					</button>
				</nav>`,
			},
			{
				Hash: 'ObservationSearch-Pagination-State',
				Template: /*html*/`
				<div id="ObservationSearch-Pagination-State" class="pagination-state" aria-label="pagination state">
					<p class="is-size-7 has-text-grey">Page {~D:Context[0].CurrentSearchFilters.CurrentPage~} of {~D:Context[0].CurrentSearchFilters.TotalPages~} ({~HumanCount:Context[0].CurrentSearchFilters.TotalResultCount^0~} total records)</p>
				</div>`,
			},
			{
				Hash: 'ObservationSearch-Results-Empty',
				Template: /*html*/`
				<div class="notification m-3 empty-message">
					<p class="has-text-centered">
						<span class="icon is-large">
							<i class="fas fa-search"></i>
						</span>
						<span>We could not find any observations based on the current search criteria.</span>
					</p>
				</div>`,
			},
			{
				Hash: 'ObservationSearch-Results-User',
				Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
			},
			{
				Hash: 'ObservationSearch-Results-Project',
				Template: /*html*/`{~D:Record.Name~}`,
			},
		],
	Renderables:
		[
			{
				RenderableHash: 'ObservationSearch-Entry',
				TemplateHash: 'ObservationSearch-Entry',
				DestinationAddress: '#ObservationSearch-Entry-Container',
			},
			{
				RenderableHash: 'ObservationSearch-Entry-ProjectSelector',
				TemplateHash: 'ObservationSearch-Entry-ProjectSelector',
				DestinationAddress: '#ObservationSearch-Entry-ProjectSelector',
			},
			{
				RenderableHash: 'ObservationSearch-Entry-ObservationTypeSelector',
				TemplateHash: 'ObservationSearch-Entry-ObservationTypeSelector',
				DestinationAddress: '#ObservationSearch-Entry-ObservationTypeSelector',
			},
			{
				RenderableHash: 'ObservationSearch-Entry-ActiveFilterCount',
				TemplateHash: 'ObservationSearch-Entry-ActiveFilterCount',
				DestinationAddress: '#ObservationSearch-Entry-ActiveFilterCount',
			},
			{
				RenderableHash: 'ObservationSearch-Results',
				TemplateHash: 'ObservationSearch-Results',
				DestinationAddress: '#ObservationSearch-Results-Container',
			},
			{
				RenderableHash: 'ObservationSearch-Pagination',
				TemplateHash: 'ObservationSearch-Pagination',
				DestinationAddress: '#ObservationSearch-Pagination-Container',
			},
			{
				RenderableHash: 'ObservationSearch-Pagination-State',
				TemplateHash: 'ObservationSearch-Pagination-State',
				DestinationAddress: '#ObservationSearch-Pagination-State-Container',
			},
		],
};
